import { render, staticRenderFns } from "./StorageBase.vue?vue&type=template&id=e883c578&"
import script from "./StorageBase.vue?vue&type=script&lang=js&"
export * from "./StorageBase.vue?vue&type=script&lang=js&"
import style0 from "./StorageBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports